import type { PhotoUploadLinkInfoMapDto } from '@app/api/routes/monitoringTasks/dtos'

export const getPhotoUploadLinkInfoMapFromResponse = (
  photoUploadLinksResponse: PhotoUploadLinkInfoMapDto[]
): PhotoUploadLinkInfoMapDto => {
  return photoUploadLinksResponse.reduce((resultPhotoUploadLinkInfoMap, currentPhotoUploadLinkInfoMap) => {
    const photoName = Object.keys(currentPhotoUploadLinkInfoMap)[0]

    resultPhotoUploadLinkInfoMap[photoName] = Object.values(currentPhotoUploadLinkInfoMap)[0]

    return resultPhotoUploadLinkInfoMap
  }, {})
}
